<template>
  <div :id='id' class="storageChart">
  </div>
</template>

<script>
  import * as echarts from 'echarts';

export default {
    name: 'storageChart',
    components: {
    },
    props: {
        chartData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            id: this.chartData.id,
            occupyColor: this.chartData.occupyColor,
            emptyColor: this.chartData.emptyColor,
            textContent: this.chartData.textContent,
            textColor: this.chartData.testColor,
            myChart: null,
            option: null,
        };
    },
    watch: {
        chartData: {
            handler(newVal) {
                this.initOptions(newVal);
                this.myChart.setOption(this.option);
            },
            deep: true,
        },
    },
    methods: {
        refresh() {
            this.myChart.setOption(this.option);
        },
        initOptions(chartData) {
            this.option = {
                backgroundColor: '#ffffff',
                tooltip: {
                    trigger: 'item',
                    formatter: '{b} : {d}%',
                },
                title: {
                    text: `${chartData.textContent}%`,
                    x: 'center',
                    y: '50%',
                    textStyle: {
                        fontSize: 20,
                        fontWeight: 'bold',
                        color: '#47C2FF',
                    },
                },
                series: [
                    {
                        type: 'pie',
                        radius: ['40%', '65%'],
                        center: ['50%', '50%'],
                        top: '10%',
                        color: [chartData.occupyColor, chartData.emptyColor],
                        itemStyle: {
                            normal: {
                                borderWidth: 2,
                                borderColor: '#ffffff',
                            },
                        },
                        data: [
                            {
                                value: chartData.textContent,
                                name: '使用空间',
                                selected: true,
                            },
                            {
                                value: (100 - chartData.textContent).toFixed(1),
                                //   value: 100 - chartData.textContent,
                                name: '剩余空间',
                            },
                        ],
                        labelLine: {
                            normal: {
                                show: true,
                                length: 20,
                                length2: 0,
                                lineStyle: {
                                    width: 1,
                                },
                            },
                        },
                        label: {
                            normal: {
                                formatter: '{b|{b}}\n{c|{c}%}',
                                rich: {
                                    b: {
                                        fontSize: 14,
                                        color: ' #333333',
                                        align: 'left',
                                        padding: 4,
                                    },
                                    c: {
                                        fontSize: 14,
                                        align: 'center',
                                        padding: 4,
                                        color: chartData.textColor,
                                    },
                                },
                            },
                        },
                    }],
            };
        },
    },
    mounted() {
        this.myChart = echarts.init(document.getElementById(this.chartData.id));
        this.initOptions(this.chartData);
        this.myChart.setOption(this.option);
    },
};
</script>

<style scoped lang='stylus' rel='stylesheet/stylus'>
  @import '~common/stylus/variable'
  @import '~common/stylus/mixin'
  .storageChart
    height 100%
    width 100%
</style>



// WEBPACK FOOTER //
// src/pages/devCenter/consoleLab/myAccount/account-storage-chart.vue